import {i18n} from '../utils/i18n-util';
import {Time} from '../interfaces/time';
/**
 * This class purposefully has functions that match those from Date.
 * The reason is so someone wanting to pass a Date object into the pds-time-widget, or the
 * validation engine time rules they can do so and the code won't break.
 */
export class SimpleTime implements Time {

  private hours: number;
  private minutes: number;

  constructor(hours: number | string, minutes?: number) {
    if (typeof hours === 'number') {
      this.setHours(hours);
      this.setMinutes(minutes || 0);
    } else if (typeof hours === 'string') {
      let t = i18n.parse24HourTime(hours);
      if (t != null) {
        this.set(t);
      }
    } else {
      this.setHours(0);
      this.setMinutes(0);
    }
  }

  to24HourTime(): string {
    let hours: number | string = this.getHours();
    let minutes: number | string = this.getMinutes();

    if (hours < 10) {
      hours = '0' + hours;
    }

    if (minutes < 10) {
      minutes = '0' + minutes;
    }

    return hours + ':' + minutes;
  }

  getHours(): number {
    return this.hours;
  }

  getMinutes(): number {
    return this.minutes;
  }
  setHours(hours: number): void {
    let hrs = hours % 24;
    if (hrs >= 0) {
      this.hours = hrs;
    } else {
      //24 - hrs, but hrs is already negative
      this.hours = 24 + hrs;
    }
  }

  setMinutes(minutes: number): void {
    let overHours = Math.floor(minutes / 60);
    this.setHours(this.hours + overHours);
    let min = minutes % 60;
    if (min >= 0) {
      this.minutes = min;
    } else {
      //60 - min, but min is already negative
      this.minutes = 60 + min;
    }

  }

  getTime(): number {
    return (this.hours * 60 + this.getMinutes()) * 60000;
  }

  set(time: Time): void {
    this.setHours(time.getHours());
    this.setMinutes(time.getMinutes());
  }
}
